import { render, staticRenderFns } from "./aset.vue?vue&type=template&id=6a5590c4&"
import script from "./aset.vue?vue&type=script&lang=js&"
export * from "./aset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports